import { render } from "./pinCard.vue?vue&type=template&id=ef820152&scoped=true"
import script from "./pinCard.vue?vue&type=script&lang=js"
export * from "./pinCard.vue?vue&type=script&lang=js"

import "./pinCard.vue?vue&type=style&index=0&id=ef820152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef820152"]])

export default __exports__